import { render, staticRenderFns } from "./ShootingChart.vue?vue&type=template&id=6ef0ff40&scoped=true&"
import script from "./ShootingChart.vue?vue&type=script&lang=js&"
export * from "./ShootingChart.vue?vue&type=script&lang=js&"
import style0 from "./ShootingChart.vue?vue&type=style&index=0&id=6ef0ff40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef0ff40",
  null
  
)

export default component.exports